export const COUNTRIES = Object.freeze({
  FETCH_COUNTRIES: 'COUNTRIES.FETCH_COUNTRIES',
});

export const HOMEPAGE = Object.freeze({
  SET_ACTIVE_TAB: 'HOMEPAGE.SET_ACTIVE_TAB',
  SET_CURRENT_FEED_DATA: 'HOMEPAGE.SET_CURRENT_FEED_DATA',
  SET_DEFAULT_FEED_DATA: 'HOMEPAGE.SET_DEFAULT_FEED_DATA',
  SET_HOMEPAGE_BACKGROUND_POSITION: 'HOMEPAGE.SET_HOMEPAGE_BACKGROUND_POSITION',
  SET_IS_DISCOVER_TAB_OPEN: 'HOMEPAGE.SET_IS_DISCOVER_TAB_OPEN',
  SET_IS_LOADING: 'HOMEPAGE.SET_IS_LOADING',
  SET_OPEN_TAB_SCROLL_POSITION: 'HOMEPAGE.SET_OPEN_TAB_SCROLL_POSITION',
  SET_VISITED_BY_BACK_BUTTON: 'HOMEPAGE.SET_VISITED_BY_BACK_BUTTON',
});

export const SEARCH = Object.freeze({
  SET_CURRENT_SEARCH_TERM: 'SEARCH.SET_CURRENT_SEARCH_TERM',
});
